<template>
  <li>
    <input type="checkbox"
           :id="uniqueId"
           :name="name"
           :value="uniqueId"
           @change="onChange"
           :checked="isChecked"
           :disabled="disabled"
    >
    <label :for="uniqueId" :class="{deleted: deleted}">
      <slot></slot>
    </label>
  </li>
</template>

<script>
export default {
  name: "ListCheckboxInput",
  props: {
    id: [String, Number],
    groupId: {
      type: String,
      default: null,
    },
    name: String,
    value: [String, Number],
    selectedEntities: {
      type: Array,
      default: [],
    },
    deleted: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    isChecked() {
      if (typeof this.id === "string") {
        return this._.includes(this.selectedEntities, this.id)
      } else {
        return this._.includes(this.selectedEntities, Number(this.id))
      }
    },
    uniqueId() {
      if (this.groupId !== null) {
        return this.groupId + '-' + this.id
      }
      return this.id
    }
  },
  methods: {
    onChange: function (e) {
      if (typeof this.id === "string") {
        this.$emit('input', {checked: e.target.checked, id: this.id})
      } else {
        this.$emit('input', {checked: e.target.checked, id: Number(this.id)})
      }
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/common/ListCheckboxInput.vue